import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function ScraperUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-1700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1701">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1702">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1703">
            Google Maps data for every{' '}
            <span className="text-blue-600" data-id="element-1704">use case</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-1705">
            Whether you're generating leads, researching markets, or analyzing
            competitors — our Google Maps scraper powers your growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1706">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-1707">
            <div data-id="element-1708">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1709">
                B2B lead generation
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-1710">
                Use our Google Maps email extractor to build highly targeted
                lists of local business owners for cold email and calling
                campaigns.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-1711">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-1712" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-1713">
                We generate 5,000 qualified leads per week from Google Maps data
                alone.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-1714">
                — James T., Growth marketer
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-1715">
            <div data-id="element-1716">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1717">
                Market research
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-1718">
                Analyze local business density, ratings, and reviews across any
                geography to inform expansion decisions.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-1719">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-1720" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-1721">
                Google Maps data from Openmart helped us identify 3 underserved
                markets in our first week.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-1722">
                — Sarah M., Strategy lead
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-1723">
            <div data-id="element-1724">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-1725">
                Competitor analysis
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-1726">
                Track competitor locations, ratings, and review sentiment at
                scale using structured Google Maps data.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-1727">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-1728" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-1729">
                We monitor 10,000 competitor locations and their review trends
                automatically.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-1730">
                — David C., Marketing director
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}